import {
  Stethoscope,
  GraduationCap,
  Hotel,
  Home,
  Palette,
  ShoppingBag,
  Factory,
  UtensilsCrossed,
  Building2,
  Shirt,
  Gem,
  Store,
  Dumbbell,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

const INDUSTRIES = [
  { icon: Stethoscope, label: "Hospitals & Diagnostics", slug: "hospitals-diagnostics" },
  { icon: GraduationCap, label: "Education", slug: "education" },
  { icon: Hotel, label: "Hotels & Resorts", slug: "hotels-resorts" },
  { icon: Home, label: "Villas & Home Stays", slug: "villas-home-stays" },
  { icon: Palette, label: "Handicrafts", slug: "handicrafts" },
  { icon: ShoppingBag, label: "E-Commerce", slug: "e-commerce" },
  { icon: Factory, label: "Industrial", slug: "industrial" },
  { icon: UtensilsCrossed, label: "Restaurants & Cafes", slug: "restaurants-cafes" },
  { icon: Building2, label: "Real Estate", slug: "real-estate" },
  { icon: Shirt, label: "Beauty & Fashion", slug: "beauty-fashion" },
  { icon: Gem, label: "Luxury & Lifestyle", slug: "luxury-lifestyle" },
  { icon: Store, label: "Local Businesses", slug: "local-businesses" },
  { icon: Dumbbell, label: "Fitness & Wellness", slug: "fitness-wellness" },
];

export const Industries = () => (
  <section data-testid="industries-section" className="relative py-24 lg:py-32 border-t border-white/[0.05] overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute -left-40 top-1/4 w-[500px] h-[500px] bg-[#6D00FF]/8 blur-[180px] rounded-full pointer-events-none"
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-2xl mb-14 lg:mb-16">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#8B2CFF] mb-6">
            Who We Move
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight leading-[1.05]">
            Industries <span className="text-gradient-purple">we serve.</span>
          </h2>
          <p className="mt-6 text-base text-[#A6A6B0] leading-relaxed">
            Strategy, design and AI-powered growth — shaped for the realities of your industry.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {INDUSTRIES.map((ind, i) => (
          <Reveal key={ind.label} delay={(i % 4) * 0.07} y={20}>
            <Link
              to={`/industries/${ind.slug}`}
              data-testid={`industry-card-${i}`}
              className="group h-full glass-card rounded-lg p-6 flex items-center gap-4 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1 hover:border-[#6D00FF]/40 hover:shadow-[0_0_36px_-12px_rgba(109,0,255,0.5)]"
            >
              <span className="w-10 h-10 shrink-0 rounded-md border border-white/10 flex items-center justify-center transition-[border-color,box-shadow] duration-500 group-hover:border-[#8B2CFF]/60 group-hover:shadow-[0_0_18px_-4px_rgba(139,44,255,0.6)]">
                <ind.icon
                  className="w-5 h-5 text-[#8B2CFF] group-hover:text-[#C43CFF] transition-colors duration-500"
                  strokeWidth={1.5}
                />
              </span>
              <span className="font-display text-sm font-bold uppercase tracking-[0.08em] text-white/80 group-hover:text-white transition-colors duration-300">
                {ind.label}
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
